
export const notificationColumns=[

    {
        field: 'checked',
        filterable: true,
        width: 40,
        hidden:false,
        columnMenu:false,
        sortable:false,
        title: ''
    },
    {
        field: 'created_at',
        filterable: true,
        width: 100,
        hidden:false,
        filter: 'date',
        format: '{0:dd.MM.yyyy HH:mm}',
        title: 'date'
    },
    {
        field: 'projectName',
        filterable: true,
        width: 100,
        hidden:false,
        title: 'Projekt'
    },
    {
        field: 'module',
        filterable: true,
        width: 100,
        hidden:false,
        title: 'Modul'
    },
    {
        field: 'message',
        filterable: true,
        width: 100,
        hidden:false,
        title: 'description'
    },
    {
        field: 'done',
        filterable: true,
        width: 100,
        hidden:false,
        title: 'Status'
    },
    {
        field: 'function',
        filterable: true,
        width: 150,
        hidden:false,
        title: 'function',
        columnMenu:false,
        sortable:false,
    },
    {
        field: 'forwardedByUser',
        filterable: true,
        width: 100,
        hidden:false,
        title: 'Weitergeleitet von'
    },
   
];